import React, { useContext } from "react";
import styled from "styled-components";
import { ErrorMessage, Form, Formik } from "formik";
import HelperObj from "../../helpers/HelperObj";
import MessageError from "../upgraded/MessageError";
import { InputField, InputPhoneField } from "../upgraded/WithFormik";
import * as yup from "yup";
import { ConnectedFocusError } from "focus-formik-error";
import FormikNotify from "../upgraded/FormikNotify";
import Button from "../Button";
import { ReactComponent as EmailSVG } from "../../assets/svg/at.svg";
import { ReactComponent as PhoneSVG } from "../../assets/svg/phone.svg";
import { ReactComponent as CuponSVG } from "../../assets/svg/cupon.svg";
import FieldInformation from "../upgraded/FieldInformation";
import { UserContext } from "../../contexts/UserContext";
import { useCourse } from "../../hooks/useCourse";

const FormGeneralData = ({
  courseId = undefined,
  values,
  errors,
  touched,
  onChange,
  onBack,
  onSubmit,
}) => {
  const userContext = useContext(UserContext);

  const { course } = useCourse({ courseId });

  return (
    <Formik
      enableReinitialize={true}
      initialValues={HelperObj.mixin(
        {
          correo: userContext?.email || "",
          isUserLogged: userContext?.email === undefined,
          telefonoCelular: "",
          cupon: "",
        },
        values
      )}
      initialErrors={errors}
      initialTouched={touched}
      validationSchema={yup.object({
        correo: yup
          .string()
          .email("No has ingresado un correo correcto.")
          .required("Es obligatorio completar este dato."),
        isUserLogged: yup.bool(),
        telefonoCelular: yup
          .string()
          .required("Es obligatorio completar este dato."),
        cupon: yup.string(),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        const valuesCleaned = HelperObj.clean(values);
        onSubmit(valuesCleaned, () => {
          setSubmitting(false);
        });
      }}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        submitForm,
        isSubmitting,
      }) => (
        <Form>
          <FormikNotify onChange={onChange} />
          <ConnectedFocusError />
          <Container>
            <ContainerQuestion>
              <InputField
                name="correo"
                placeholder="Correo"
                iconSVGRight={EmailSVG}
                readOnly={values.isUserLogged === false}
                hasError={touched.correo && errors.correo}
              />
              <ErrorMessage name="correo">
                {(msg) => <MessageError messageError={msg} />}
              </ErrorMessage>
            </ContainerQuestion>
            <ContainerQuestion>
              <InputField
                name="telefonoCelular"
                placeholder="Número de celular"
                iconSVGRight={PhoneSVG}
                hasError={touched.telefonoCelular && errors.telefonoCelular}
              />

              <ErrorMessage name="telefonoCelular">
                {(msg) => <MessageError messageError={msg} />}
              </ErrorMessage>
            </ContainerQuestion>
            {course.isPromotion && (
              <ContainerQuestion>
                <InputField
                  name="cupon"
                  placeholder="Cupón de descuento"
                  iconSVGRight={CuponSVG}
                  hasError={touched.cupon && errors.cupon}
                />

                <ErrorMessage name="cupon">
                  {(msg) => <MessageError messageError={msg} />}
                </ErrorMessage>

                <FieldInformation message="Si no tienes cupón, no completes" />
              </ContainerQuestion>
            )}
          </Container>
          <ButtonWrapper>
            <ButtonStyled
              primary={true}
              text="Siguiente"
              loading={isSubmitting}
              onClick={() => {
                submitForm();
              }}
            />
          </ButtonWrapper>
        </Form>
      )}
    </Formik>
  );
};

const Container = styled.div``;

const ContainerQuestion = styled.div`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  margin-top: 35px;
`;

const ButtonStyled = styled(Button)`
  flex: 1 0;
  .button {
    background-color: #226dd4;
    padding: 20px;
  }
`;

export default FormGeneralData;
